<h3 *ngIf="isError">วิดีโอกำลังประมวลผลกรุณารอสักครู่แล้วเปิดหน้าต่างนี้ใหม่</h3>
<mat-spinner *ngIf="isError" style="margin: auto"></mat-spinner>
<div #videoPlayerContainer></div>

<!-- <div>
        <iframe
            [src]="videoUrl"
            frameborder="0"
            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen></iframe>
    </div> -->
